module.exports = __webpack_public_path__ + "static/media/directions-white.7f2df7ad.svg";